export const MAIN_BRANCH_ID = 'main';
export const TRACER_NAME = 'sourcerer';
export const DRAFT_BRANCH_ID = 'draft';
export const SAMPLE_PROJECT_ACCOUNT = 'SAMPLE_PROJECT_ACCOUNT';
export const SYSTEM_EMAIL = 'system@poly-ai.com';

export const DEPLOYED_CLIENT_ENV = {
  SANDBOX: 'sandbox',
  PRE_RELEASE: 'pre-release',
  LIVE: 'live',
};

export const CLIENT_ENV = {
  ...DEPLOYED_CLIENT_ENV,
  DRAFT: 'draft',
};

export const IS_PROJECTION_CACHE_ENABLED = 'IS_PROJECTION_CACHE_ENABLED';

export const RAGDOLL_DEFAULT_EMBEDDING_MODEL =
  'sentence-transformers/gtr-t5-base';
